import { DriverResource } from "../api/drivers/get";
import { CreateDriverRequest, UpdateDriverRequest } from "../api/drivers/create";

export class EditDriverModel {
  id: number = null;
  name: string;
  carrier: string;
  facilityCode: string;
  visible: boolean = false;
  loading: boolean = true;
  isActive: boolean = true;
  saving: boolean = false;
  phoneNumber: string;
  emailAddress: string;

  get isNew() {
    return this.id === null;
  }

  showForNewDriver(facilityCode: string) {
    this.loading = false;
    this.facilityCode = facilityCode;
  }

  showForExistingDriver(driver: DriverResource) {
    this.loading = false;
    this.id = driver.id;
    this.name = driver.driverName;
    this.facilityCode = driver.facilityCode;
    this.carrier = driver.carrier;
    this.emailAddress = driver.emailAddress;
    this.phoneNumber = driver.phoneNumber;
    this.isActive = driver.isActive;
  }

  toCreateDriverRequest(): CreateDriverRequest {
    return { driverName: this.name, facilityCode: this.facilityCode, carrier: this.carrier, emailAddress: this.emailAddress, phoneNumber: this.phoneNumber?.replace(/\D/g, '') };
  }

  toUpdateDriverRequest(): UpdateDriverRequest {
    return {
      id: this.id,
      facilityCode: this.facilityCode,
      carrier: this.carrier,
      isActive: this.isActive,
      driverName: this.name,
      emailAddress: this.emailAddress,
      phoneNumber: this.phoneNumber?.replace(/\D/g, '') 
    };
  }
}
